






















import _ from 'lodash';
import moment from 'moment';
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';

import Batch from '@/classes/Batch';
import DatePicker from '@/components/Misc/DatePicker.vue';
import IdBadge from '@/components/Misc/IdBadge.vue';
import TagBadge from '@/components/Misc/TagBadge.vue';
import { ITag } from '@/interfaces';
import { upsertList } from '@/main';
import BatchesModule from '@/store/modules/BatchesModule';

const batchesModule = getModule(BatchesModule);

export default Vue.extend({
  components: {
    DatePicker,
    IdBadge,
    TagBadge,
  },
  props: ['isEditing', 'originalCopy'],
  data() {
    return {
      workingCopy: _.cloneDeep(this.originalCopy as Batch),
      cutOffDate: moment(this.originalCopy.cutoffdate).format('YYYY-MM-DD'),
      shipDate: moment(this.originalCopy.shipdate).format('YYYY-MM-DD'),
      receiveDateFrom: moment(this.originalCopy.receivedatefrom).format('YYYY-MM-DD'),
      receiveDateTo: moment(this.originalCopy.receivedateto).format('YYYY-MM-DD'),
      newTagText: '',
      submitError: '',
    };
  },
  methods: {
    cancel() {
      if (confirm('確定要取消?')) {
        this.workingCopy = _.cloneDeep(this.originalCopy);
        this.$emit('cancel');
      }
    },
    save() {
      batchesModule.apiUpdateBatch({ batch: this.workingCopy }).then((response) => {
        if (response.success === false) {
          this.submitError = response.error.message;
          return;
        }
        this.$emit('saved');
      });
    },
    reset() {
      if (confirm('確定要重置?')) {
        this.workingCopy = _.cloneDeep(this.originalCopy);
      }
    },
    cutOffDateUpdated(date: string) {
      this.workingCopy.cutoffdate = moment(date);
    },
    shipDateUpdated(date: string) {
      this.workingCopy.shipdate = moment(date);
    },
    receiveDateFromUpdated(date: string) {
      this.workingCopy.receivedatefrom = moment(date);
    },
    receiveDateToUpdated(date: string) {
      this.workingCopy.receivedateto = moment(date);
    },
  },
});
